/* eslint-disable */
export const encarMobileAppCheck = () => {
	var ua, webViewName, os, v, version;
	var toString = function (str) {
		return str == null || str == '' ? '' : str.toString();
	};
	ua = global.navigator?.userAgent;
	webViewName = ua?.toLowerCase().match(/(webview)_(android|ios|iphone)/g);
	os = toString(toString(webViewName).match(/android|ios|iphone/g));
	version = toString(toString(ua?.match(/version(([0-9].{1,}\d+)?)/g)).match(/[0-9].{1,}\d+?$/g));
	return {
		isApp: webViewName == null ? false : true,
		appInfo: { os: os, version: version },
		version: version,
		appOs: function () {
			if (os == 'iphone') {
				os = 'ios';
			}
			return os;
		},
		// 안드로이드 앱 이용인지 체크
		isAndroidApp: os == 'android',
		// 애플 재품의 앱을 이용한것인지 체크
		isIosApp: os == 'ios',
		isMobile:
			/iPhone|iPod|iPad|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i.test(
				ua,
			),
		isAndroidBrowser: /Android/i.test(ua),
		isIosBrowser: /iPhone|iPod|iPad/i.test(ua),
	};
};

export default null;
